const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/store/arbeitgeber.ts';
import Imm from 'immutable';
import { createSelector } from 'reselect';
import { Logger } from '@cistec/common_web/services/KisLoggerService';
import { IActionHandlersMap, IKisApiHandlersMap, makeReducer } from '@cistec/common_web/defs/actionTypes';
import { decCounter, incCounter } from '@cistec/common_web/utils/reducerUtils';
import { useRemoteData } from '@cistec/common_web/hooks/useRemoteData';
import { loadArbeitgeberRecords, REQUEST_ACTION_TYPES_LOAD_ARBEITGEBER_RECORDS } from 'App/actions/arbeitgeber';
import { PatAppStoreState } from './setup/rootReducer';
import { getPatNrFromSession } from 'App/utils/sessionStorage';

const emptyMap = Imm.Map<string, any>();

const Log = Logger('arbeitgeberReducer');

export const arbeitgeberHandler: IKisApiHandlersMap = {
    pending: state => {
        return incCounter(state, ['loading']);
    },

    success: (state, action) => {
        const list = Imm.fromJS(action?.payload?.List || {});

        state = state.set('data', Object.values(action?.payload?.List || {}));
        return decCounter(state, ['loading']);
    },

    failure: (state, _action) => {
        Log.error(`Failed to load arbeitgeber item`);
        return decCounter(state, ['loading']);
    },
};

const handlers: IActionHandlersMap = {
    [REQUEST_ACTION_TYPES_LOAD_ARBEITGEBER_RECORDS.pending]: arbeitgeberHandler.pending,
    [REQUEST_ACTION_TYPES_LOAD_ARBEITGEBER_RECORDS.success]: arbeitgeberHandler.success,
    [REQUEST_ACTION_TYPES_LOAD_ARBEITGEBER_RECORDS.failure]: arbeitgeberHandler.failure,
};

export const arbeitgeberReducer = makeReducer(handlers, Imm.Map<string, any>());

export const arbeitgeber = (state: PatAppStoreState): Imm.Map<string, any> => state.arbeitgeber;

export const arbeitgeberIsLoading = (state: PatAppStoreState): boolean =>
    state.arbeitgeber.get('loading') && state.arbeitgeber.get('loading') > 0;

// TODO: Change to JSON
export const arbeitgeberOfCurPatSelector = createSelector(
    [arbeitgeber],
    (arbeitgeberList: Imm.Map<string, any>): Imm.Map<string, any> => {
        const arbeitgeber = arbeitgeberList?.get('data');
        const result = arbeitgeber?.filter((item: any) => item.Status !== 'I')[0];
        return Imm.Map(result) || emptyMap;
    }
);

export function useArbeitgeberData() {
    const patNr = getPatNrFromSession();
    return useRemoteData({}, () => ({
        isLoading: arbeitgeberIsLoading,
        select: arbeitgeberOfCurPatSelector,
        shouldFetch: state => {
            const arbeitgeber = arbeitgeberOfCurPatSelector(state);
            return !arbeitgeber || !arbeitgeber.size;
        },
        fetch: (dispatch, state) => {
            dispatch(loadArbeitgeberRecords(patNr));
        },
        noRefetch: true,
    }));
}
